export const SURVEY_OPTIONS = [
  { code: 'creon_consumers_ru_kz', labelKey: 'kazakhstanConsumer', country: 'KZ', segment: 'consumer' },
  { code: 'creon_consumers_ru_kz_doc', labelKey: 'kazakhstanDoctor', country: 'KZ', segment: 'doc' },
  { code: 'creon_consumers_ua', labelKey: 'ukraineConsumer', country: 'UA', segment: 'consumer' },
  { code: 'creon_consumers_ua_doc', labelKey: 'ukraineDoctor', country: 'UA', segment: 'doc' },
  { code: 'creon_consumers_ru_en', labelKey: 'legacyFusion', country: 'KZ', segment: 'legacy' },
  { code: 'eurobank_implicit_rt', labelKey: 'damasAdTest', country: 'GR', segment: 'implicit_rt' },
  { code: 'gen_z_mk_neuro', labelKey: 'genZMk', country: 'MK', segment: 'consumer' },
  { code: 'gen_z_rs_neuro', labelKey: 'genZRs', country: 'RS', segment: 'consumer' },
  { code: 'gen_z_xk_neuro', labelKey: 'genZXk', country: 'XK', segment: 'consumer' },
  { code: 'gen_z_me_neuro', labelKey: 'genZMe', country: 'ME', segment: 'consumer' },
]

export const SURVEY_BY_CODE = Object.fromEntries(
  SURVEY_OPTIONS.map((survey) => [survey.code, survey])
)
